import Swiper from "swiper";
import { Navigation } from 'swiper/modules';

const rendingResourcesCarousel = document.querySelectorAll(".features-cards");

rendingResourcesCarousel.forEach((slider, index) => {
    const Carousel = slider.querySelector(".swiper");
    const prevArrow = slider.querySelector(".swiper-button-prev");
    const nextArrow = slider.querySelector(".swiper-button-next");
    const slides = slider.querySelectorAll('.swiper-wrapper > *');
    const slideCount = slides.length;

    let breakpointSettings = {
        792: {
            slidesPerView: 3,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
        }
    };

    if (slideCount === 2 || slideCount === 4) {
        breakpointSettings = {
            792: {
                slidesPerView: 2,
                slidesOffsetAfter: 0,
                slidesOffsetBefore: 0,
            },
            1024: {
                slidesPerView: slideCount === 4 ? 4 : 2,
                slidesOffsetAfter: 0,
                slidesOffsetBefore: 0,
            }
        };
    }

    new Swiper(Carousel, {
        modules: [Navigation],
        slidesPerView: "auto",
        centerInsufficientSlides: true,
        spaceBetween: 20,
        slidesOffsetAfter: 20,
        slidesOffsetBefore: 20,
        navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
        },
        breakpoints: breakpointSettings
    });
});
